import { AnbFormGroup, DropdownModel } from '@anb/ng-forms';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LabelClient } from '@core/api/proxy';
import { BaseFormComponent } from '@shared/models/base-form.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css'],
})
export class DownloadComponent extends BaseFormComponent implements OnInit {
  form: AnbFormGroup<any>;
  dropdownValues: Array<DropdownModel> = new Array<DropdownModel>();
  allow = false;
  constructor(private client: LabelClient, private fb: FormBuilder) {
    super();
    const form = this.fb.group({
      ['jaar']: [null, Validators.required],
    });
    this.form = new AnbFormGroup(form.controls, form.validator);
  }
  ngOnInit(): void {
    this.dropdownValues.push(new DropdownModel('placeHolder', 'Select jaar'));
    this.client.getYears().subscribe((years) => {
      years.forEach((y) => {
        const dropdownValue = {
          dropdownModelID: y.toString(),
          description: y.toString(),
        } as DropdownModel;
        this.dropdownValues.push(dropdownValue);
      });
      this.allow = true;
    });
  }

  downloadCsv(): void {
    const jaar = this.form.get('jaar')?.value as number;
    if (jaar) {
      this.client.downloadLabels(jaar).subscribe((result) => {
        saveAs(result.data, `Labels_${jaar}.csv`);
      });
    }
  }
}
